/**
 * @module Page-Payment-Solutions
 */

import { BANNER_TYPE } from "../../../globals/constants";
import { useEffect } from "react";
import { loadScript } from "../../../globals/common-functions";
import banner from "../../../globals/banner.json";
import AvertImage from "../../../globals/elements/avertimg";
import SectionInnerPageBanner from "../../sections/common/banner";

function PaymentSolutionsPage() {

    useEffect(()=>{
        loadScript("js/custom.js");
    })

    return (

        <div className="av-sv2-wrap">
            <SectionInnerPageBanner _data={banner.service_detail} _type={BANNER_TYPE.COMPACT} />

            {/* Hero */}
            <div className="section-full p-t120 p-b0 site-bg-white">
                <div className="container">
                    <div className="av-hero-v2">
                        <div className="row align-items-center">
                            <div className="col-lg-7">
                                <div className="av-hero-eyebrow">
                                    <i className="feather feather-credit-card"></i>
                                    Payment Systems
                                </div>
                                <h1>Payment Solutions & Integration</h1>
                                <p className="av-hero-lead">
                                    Getting paid should be simple — for you and your customers. We set up secure
                                    payment systems that work with your business, whether that's online, mobile money,
                                    or recurring subscriptions.
                                </p>
                            </div>
                            <div className="col-lg-5">
                                <div className="av-hero-visual">
                                    <AvertImage src="images/services/payment-solutions.jpg" alt="Payment Solutions & Integration" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Payment Types */}
            <div className="av-section-v2 av-bg-slate">
                <div className="container">
                    <div className="av-sh">
                        <div className="av-sh-label">Payment Options</div>
                        <h2>Ways Your Customers Can Pay</h2>
                        <p>Different customers prefer different payment methods. We make sure you can accept them all.</p>
                    </div>

                    <div className="row">
                        <div className="col-lg-4 col-md-6 m-b30">
                            <div className="av-card-v2">
                                <div className="av-card-icon">
                                    <i className="feather feather-globe"></i>
                                </div>
                                <h3>Online Payments</h3>
                                <p>Credit cards, bank transfers, and digital wallets through your website or app. A smooth checkout that doesn't lose customers at the last step.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 m-b30">
                            <div className="av-card-v2">
                                <div className="av-card-icon">
                                    <i className="feather feather-smartphone"></i>
                                </div>
                                <h3>Mobile Money</h3>
                                <p>MTN Mobile Money, Airtel Money, and other local providers. Essential for reaching customers across Uganda and East Africa.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 m-b30">
                            <div className="av-card-v2">
                                <div className="av-card-icon">
                                    <i className="feather feather-repeat"></i>
                                </div>
                                <h3>Recurring Billing</h3>
                                <p>Subscriptions, membership fees, and regular payments that run automatically. Set it up once and let it handle itself.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Features + Partners */}
            <div className="av-section-v2">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 m-b30">
                            <div className="av-panel-accent" style={{height: '100%'}}>
                                <h3>What's included</h3>
                                <p>Every payment integration we build comes with these essentials.</p>

                                <div className="av-feature-row">
                                    <div className="av-fr-icon"><i className="feather feather-shield"></i></div>
                                    <div>
                                        <h5>Bank-level security</h5>
                                        <p>Your customers' payment data is protected with industry-standard encryption.</p>
                                    </div>
                                </div>
                                <div className="av-feature-row">
                                    <div className="av-fr-icon"><i className="feather feather-zap"></i></div>
                                    <div>
                                        <h5>Fast processing</h5>
                                        <p>Transactions go through quickly so customers aren't left waiting.</p>
                                    </div>
                                </div>
                                <div className="av-feature-row">
                                    <div className="av-fr-icon"><i className="feather feather-bar-chart-2"></i></div>
                                    <div>
                                        <h5>Real-time reporting</h5>
                                        <p>See payments, refunds, and revenue as they happen with clear dashboards.</p>
                                    </div>
                                </div>
                                <div className="av-feature-row">
                                    <div className="av-fr-icon"><i className="feather feather-dollar-sign"></i></div>
                                    <div>
                                        <h5>Multiple currencies</h5>
                                        <p>Accept payments in different currencies for international customers.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 m-b30">
                            <div className="av-panel-dark" style={{height: '100%'}}>
                                <h3>Payment partners</h3>
                                <p>We work with the providers that make sense for your business and your customers.</p>
                                <div className="av-pd-grid">
                                    <div className="av-pd-item">
                                        <i className="feather feather-credit-card"></i>
                                        <h5>Stripe</h5>
                                        <p>International card payments</p>
                                    </div>
                                    <div className="av-pd-item">
                                        <i className="feather feather-send"></i>
                                        <h5>PayPal</h5>
                                        <p>Global digital wallet</p>
                                    </div>
                                    <div className="av-pd-item">
                                        <i className="feather feather-phone"></i>
                                        <h5>MTN MoMo</h5>
                                        <p>Mobile money Uganda</p>
                                    </div>
                                    <div className="av-pd-item">
                                        <i className="feather feather-phone"></i>
                                        <h5>Airtel Money</h5>
                                        <p>Mobile money Uganda</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Industry Solutions */}
            <div className="av-section-v2 av-bg-slate">
                <div className="container">
                    <div className="av-sh">
                        <div className="av-sh-label">Industries</div>
                        <h2>Payment Solutions for Your Sector</h2>
                        <p>We've set up payment systems for a range of industries, each with its own requirements.</p>
                    </div>

                    <div className="row">
                        <div className="col-lg-3 col-md-6 m-b30">
                            <div className="av-card-v2">
                                <div className="av-card-icon">
                                    <i className="feather feather-heart"></i>
                                </div>
                                <h3>Churches & Ministries</h3>
                                <p>Tithes, offerings, and donation management with member giving portals and automated receipts.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 m-b30">
                            <div className="av-card-v2">
                                <div className="av-card-icon">
                                    <i className="feather feather-shopping-bag"></i>
                                </div>
                                <h3>E-commerce</h3>
                                <p>Complete online store checkout with cart recovery, order tracking, and multi-payment support.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 m-b30">
                            <div className="av-card-v2">
                                <div className="av-card-icon">
                                    <i className="feather feather-book-open"></i>
                                </div>
                                <h3>Education</h3>
                                <p>Tuition payments, course fees, and parent payment portals that take the headache out of school finances.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 m-b30">
                            <div className="av-card-v2">
                                <div className="av-card-icon">
                                    <i className="feather feather-activity"></i>
                                </div>
                                <h3>Healthcare</h3>
                                <p>Patient billing, insurance processing, and appointment payments — secure and compliant.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Process */}
            <div className="av-section-v2">
                <div className="container">
                    <div className="av-sh">
                        <div className="av-sh-label">Getting Started</div>
                        <h2>How We Set Things Up</h2>
                    </div>

                    <div className="row av-timeline">
                        <div className="col-lg-3 col-md-6 m-b30">
                            <div className="av-tl-step">
                                <div className="av-tl-num">1</div>
                                <h4>Requirements</h4>
                                <p>We understand your business model, who your customers are, and how they prefer to pay.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 m-b30">
                            <div className="av-tl-step">
                                <div className="av-tl-num">2</div>
                                <h4>Selection</h4>
                                <p>We recommend the best payment providers based on your location, industry, and costs.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 m-b30">
                            <div className="av-tl-step">
                                <div className="av-tl-num">3</div>
                                <h4>Integration</h4>
                                <p>We connect everything and test thoroughly to make sure payments flow without issues.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 m-b30">
                            <div className="av-tl-step">
                                <div className="av-tl-num">4</div>
                                <h4>Launch</h4>
                                <p>We train your team and provide ongoing support to keep things running smoothly.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* CTA */}
            <div className="av-section-v2 av-bg-slate">
                <div className="container">
                    <div className="av-cta-v2">
                        <h3>Ready to make it easier to get paid?</h3>
                        <p>Let's talk about what payment setup makes sense for your business and your customers.</p>
                        <div className="av-cta-actions">
                            <a href="/contact-us" className="av-btn-white">Get Started</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default PaymentSolutionsPage;
